import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class CommunicationCenterOptionsService extends SendRequest
{
    async markAsRead(params)
    {
        var url = API.client.communication.MARK_READ;
         try 
        {
            const result = await axios.put(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }

    async dismiss(params)
    {
        var url = API.client.communication.DISMISS;
        try 
        {
            const result = await axios.put(url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
            return result;
        } 
        catch (error) 
        {
          return error;
        }
    }
}
